import IndexPage from 'flarum/forum/components/IndexPage';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class ExamPage extends IndexPage {
  oninit(vnode) {
    Page.prototype.oninit.call(this, vnode);
    this.bodyClass = 'App--index';
    this.loading = true;
    this.exams = [];
    this.error = null;
    this.certLevel = app.session.user ? (app.session.user.attribute('taroWandLevel') || 'C0') : 'C0';
    this.load();
  }

  hero() {
    const hidden = app.forum.attribute('taroExamHeroHidden') || false;
    if (hidden) return null;
    const subtitle = app.forum.attribute('taroExamHeroSubtitle') || '检验学习成果，获得塔罗师认证';
    const icon = app.forum.attribute('taroExamHeroIcon') || 'fas fa-graduation-cap';
    const color = app.forum.attribute('taroExamHeroColor') || '';
    return (
      <header className="Hero" style={color ? { '--hero-bg': color } : undefined}>
        <div className="container">
          <h1 className="Hero-title">
            <i className={icon} style={{ marginRight: '8px' }} />
            考试中心
          </h1>
          {subtitle ? <div className="Hero-subtitle">{subtitle}</div> : null}
        </div>
      </header>
    );
  }

  contentItems() {
    const items = new ItemList();
    items.add('examContent', this.examContent(), 100);
    return items;
  }

  async load() {
    try {
      const res = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/exams',
      });
      this.exams = res.data || [];
    } catch (e) {
      this.error = '加载考试列表失败';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }

  canTake(targetLevel) {
    return (order_of(this.certLevel) ?? 0) < (order_of(targetLevel) ?? 0);
  }

  examContent() {
    if (this.loading) {
      return <div className="ExamPage"><LoadingIndicator /></div>;
    }

    return (
      <div className="ExamPage">
        <h2 className="ExamPage-title">考试认证</h2>
        <p className="ExamPage-subtitle">
          <i className="fas fa-certificate" /> 当前认证等级：<strong>{this.certLevel}</strong>
        </p>
        {this.exams.length === 0 && !this.error && (
          <div className="ExamPage-empty">暂无可用考试</div>
        )}
        <div className="ExamPage-list">
          {this.exams.map((exam) => {
            const a = exam.attributes || {};
            const canTake = this.canTake(a.target_level);
            const passed = (order_of(this.certLevel) ?? 0) >= (order_of(a.target_level) ?? 0);
            return (
              <div className={'ExamCard' + (canTake ? '' : ' ExamCard--disabled')} key={exam.id}>
                <div className="ExamCard-header">
                  <span className="ExamCard-level">{a.target_level}</span>
                  <h3 className="ExamCard-name">{a.title}</h3>
                </div>
                <div className="ExamCard-body">
                  <p className="ExamCard-desc">{a.description}</p>
                  <div className="ExamCard-meta">
                    <span><i className="fas fa-coins" /> {a.exam_fee} 星币</span>
                    <span><i className="fas fa-check-circle" /> 及格线 {a.passing_score}%</span>
                  </div>
                </div>
                <div className="ExamCard-action">
                  {canTake ? (
                    <LinkButton className="Button Button--primary" href={app.route('exam.take', { id: exam.id })}>
                      报考
                    </LinkButton>
                  ) : (
                    <span className="ExamCard-status">{passed ? '已通过此等级' : '需先通过低级考试'}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function order_of(level) {
  return { C0: 0, C1: 1, C2: 2, C3: 3, C4: 4 }[level];
}
